<template>
  <ItinerarySummaryCard type="car" :price="totalPrice">
    <div class="flex flex-col gap-10">
      <ItinerarySummaryCarCardContent
        v-for="car in items"
        :key="car.uniqueId"
        :car="car"
      />
    </div>
  </ItinerarySummaryCard>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import ItinerarySummaryCard from '../ItinerarySummaryCard/ItinerarySummaryCard.vue'
import type { Props } from './ItinerarySummaryCarCard.types'
import ItinerarySummaryCarCardContent from './ItinerarySummaryCarCardContent/ItinerarySummaryCarCardContent.vue'
import { useCurrency } from '@/modules/Core/composables'

const props = defineProps<Props>()

const { formatCurrency } = useCurrency()

const totalPrice = computed(() => {
  const prices = props.items.map((item) => item.price)
  const total = prices.reduce((acc, price) => acc + price, 0)

  return formatCurrency(
    Number(total.toFixed(2)),
    props.items[0].convertedCurrency
  ).value
})
</script>
